import { Link } from "react-router-dom";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";
import { FadeUp, Overline } from "@/components/Reveal";
import { Magnetic } from "@/components/Magnetic";

export default function Company() {
  return (
    <div className="bg-white min-h-screen" data-testid="company-page">
      <Seo
        title="About Royal Deals FZ-LLC — UAE Advanced Compute Supply"
        description="Royal Deals FZ-LLC is a UAE-based technology trading company specialising in advanced compute hardware, enterprise GPU systems and mission-critical IT components. Registered in Ras Al Khaimah (RAKEZ)."
      />
      <Nav />
      <main className="pt-44 pb-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <FadeUp>
            <Overline>Company</Overline>
            <h1 className="font-heading text-4xl md:text-6xl font-light tracking-tight text-midnight max-w-4xl leading-[1.05]">
              Advanced compute. Global supply. <span className="gold-text-gradient font-medium">UAE execution.</span>
            </h1>
            <p className="text-midnight/60 text-lg mt-8 max-w-2xl leading-relaxed">
              Royal Deals FZ-LLC is a UAE-based technology trading company specialising in advanced compute hardware, enterprise GPU systems and mission-critical IT components.
            </p>
          </FadeUp>

          <div className="grid md:grid-cols-2 gap-5 mt-20">
            <FadeUp>
              <div className="bg-white hairline shadow-soft p-10 h-full">
                <p className="text-xs font-bold uppercase tracking-[0.15em] text-gold mb-5">Established in the UAE</p>
                <h2 className="font-heading text-2xl font-medium text-midnight mb-4">Registered in Ras Al Khaimah</h2>
                <p className="text-midnight/55 leading-relaxed">
                  Royal Deals FZ-LLC is incorporated in the United Arab Emirates through the Ras Al Khaimah Economic Zone (RAKEZ), and serves Dubai, the GCC and international markets.
                </p>
                <dl className="mt-8 space-y-3 text-sm">
                  <div className="flex gap-4"><dt className="text-midnight/40 w-28 font-bold text-xs uppercase tracking-wide pt-0.5">Entity</dt><dd className="text-midnight font-medium">ROYAL DEALS FZ-LLC</dd></div>
                  <div className="flex gap-4"><dt className="text-midnight/40 w-28 font-bold text-xs uppercase tracking-wide pt-0.5">Licence</dt><dd className="text-midnight/75">Trade Licence No. 5040984</dd></div>
                  <div className="flex gap-4"><dt className="text-midnight/40 w-28 font-bold text-xs uppercase tracking-wide pt-0.5">Registered</dt><dd className="text-midnight/75">VUEP1860, Compass Building – Al Hulaila, Al Hulaila Industrial Zone-FZ, Ras Al Khaimah, United Arab Emirates</dd></div>
                </dl>
              </div>
            </FadeUp>
            <FadeUp delay={0.1}>
              <div className="bg-white hairline shadow-soft p-10 h-full">
                <p className="text-xs font-bold uppercase tracking-[0.15em] text-gold mb-5">Supply Channels</p>
                <h2 className="font-heading text-2xl font-medium text-midnight mb-4">Professional international sourcing</h2>
                <p className="text-midnight/55 leading-relaxed">
                  Royal Deals FZ-LLC sources products from leading global compute and technology manufacturers through professional international supply channels. Manufacturer-specific availability is provided directly against qualified enquiries.
                </p>
                <p className="text-midnight/55 leading-relaxed mt-4">
                  We operate an RFQ model: requirement, qualification, commercial negotiation, execution. No retail catalogue, no shopping cart — transactions are structured around the scale of the requirement.
                </p>
              </div>
            </FadeUp>
          </div>

          <FadeUp className="mt-20 bg-midnight p-10 lg:p-14">
            <h2 className="font-heading text-2xl md:text-3xl font-light text-white max-w-2xl">
              A UAE-based gateway into the global advanced-compute supply chain.
            </h2>
            <Magnetic className="mt-8">
              <Link to="/request" data-testid="company-cta" className="inline-block bg-gold text-midnight text-sm font-semibold px-8 py-4 hover:bg-gold-light transition-colors">
                Submit a Requirement
              </Link>
            </Magnetic>
          </FadeUp>
        </div>
      </main>
      <Footer />
    </div>
  );
}
